import { AbstractDomComponent } from './AbstractDomComponent';
import { tag } from '../../utils/tag';

export class CommentAndButtonComponent extends AbstractDomComponent {
    #text;
    #actionEvent;
    #button;
    #handleButton;
    #handleFocus;
    #buttonLabel;

    constructor(text, buttonLabel, actionEvent) {
        super();

        this.#text = text;
        this.#actionEvent = actionEvent;
        this.#buttonLabel = buttonLabel;
        this._needListeners = true;
    }

    _render(parentNode) {
        const commentEl = tag('div', 'comment', this.#text || '-');
        const uiEl = tag('div', 'ui-block');
        const buttonEl = tag('button', 'button', this.#buttonLabel);

        buttonEl.setAttribute('type', 'button');

        uiEl.appendChild(buttonEl);
        parentNode.appendChild(commentEl);
        parentNode.appendChild(uiEl);

        this.#button = buttonEl;

        return [commentEl, uiEl];
    }

    remove(clear) {
        super.remove(clear);

        if (clear) {
            this.#button = null;
        }
    }

    _addListeners() {
        if (!this.#button) return;

        this.#handleButton = () => {
            console.log(this.#actionEvent);
            this.dispatchEvent({
                ...this.#actionEvent
            });
        };

        this.#handleFocus = (evt) => {
            this.dispatchEvent({
                type: 'focusChange',
                value: evt.type
            });
        };

        this.#button.addEventListener('click', this.#handleButton);
        this.#button.addEventListener('focus', this.#handleFocus);
        this.#button.addEventListener('blur', this.#handleFocus);
    }

    _removeListeners() {
        if (!this.#button) return;

        if (typeof this.#handleButton === 'function') this.#button.removeEventListener('click', this.#handleButton);
        if (typeof this.#handleFocus === 'function') {
            this.#button.removeEventListener('focus', this.#handleFocus);
            this.#button.removeEventListener('blur', this.#handleFocus);
        }
        this.#handleButton = null;
        this.#handleFocus = null;
    }

    get text() {
        return this.#text;
    }

    set text(value) {
        this.#text = value;
    }

    get actionEvent() {
        return this.#actionEvent;
    }

    set actionEvent(value) {
        this.#actionEvent = value;
    }
}
